import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';
import { SetNewPasswordForm } from 'src/app/shared/models/auth/set-new-password-form.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html'
})
export class NewPasswordComponent implements OnInit {

  token: string;

  newPasswordForm: FormGroup;

  passwordChanged: boolean;
  constructor(
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit() {
    const routeParams = this.activeRoute.snapshot.params;
    this.createFormGroup();
    if (routeParams) {
      this.token = routeParams.token;
    }
  }

  createFormGroup() {
    this.newPasswordForm = this.fb.group({
      password: this.fb.group({
        newPassword: [null, [Validators.required, Validators.minLength(4)]],
        confirmPassword: [null, [Validators.required, Validators.minLength(4)]],
      }, { validators: this.checkPassword })
    });
  }

  setNewPassword() {
    const newPassword = this.newPasswordForm.get('password').get('newPassword').value;
    const setNewPasswordForm = new SetNewPasswordForm(newPassword, this.token);
    this.authService.setNewPassword(setNewPasswordForm).subscribe(_ => {
      this.toastrService.success('Hasło zostało ustawione, możesz się zalogować.');
      this.passwordChanged = true;
      if (this.userService.getCurrentUser) {
        this.authService.logout();
      } else {
        this.router.navigate(['/']);
      }
    }, _ => this.toastrService.error('Nie można ustawić hasła, sprawdź link bądź skontaktuj się z administratorem.'));
  }

  checkPassword(passwordGroup: FormGroup) {
    const newPassword = passwordGroup.get('newPassword').value;
    const confirmPassword = passwordGroup.get('confirmPassword').value;
    if (newPassword === confirmPassword) {
      return null;
    } else {
      passwordGroup.get('confirmPassword').setErrors({ passwordConfirmationInvalid: true })
      return { passwordConfirmationInvalid: true }
    }
  }


}
